<template>
  <mf-card-container
    v-model="search"
    title="Grupos de precificação"
    description="Conjunto de lojas que praticam os mesmos preços. Podem ser agrupadas por área geográfica, características similares ou qualquer outro critério determinado por você."
    use-search
    placeholder="Busca"
    class="mb-5"
  >
    <template v-slot:headers>
      <mf-button icon="add" label="Novo grupo" @click="openDialog = true" />
    </template>
    <paginated-data-table
      ref="table"
      key="unit-groups"
      :headers="headers"
      :search="search"
      :query="query"
      query-name="unitGroups"
      query-main-property-name="unit_groups"
      :custom-items-per-page="5"
      no-data-text="Nenhum grupo foi criado ainda. Você pode criar um novo grupo clicando no botão ”Novo Grupo” acima."
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            {{ item.name }}
          </td>
          <td>
            <v-tooltip v-for="unit in getChips(sanitizeUnits(item.units))" :key="unit.id_erp" top max-width="200px">
              <template v-slot:activator="{ on }">
                <v-chip class="mr-1 mb-1" v-on="on"> {{ putEllipsis(unit.name, 18) }} </v-chip>
              </template>
              <span>{{ unit.name }}</span>
            </v-tooltip>

            <v-tooltip v-if="sanitizeUnits(item.units).length > 4" top max-width="200px">
              <template v-slot:activator="{ on }">
                <v-chip class="mr-1 mb-1" v-on="on"> +{{ sanitizeUnits(item.units).length - 4 }} </v-chip>
              </template>
              <span>{{
                sanitizeUnits(item.units)
                  .map((unit) => unit.name)
                  .join(', ')
              }}</span>
            </v-tooltip>
          </td>
          <td>
            <mf-tooltip max-width="200" top>
              <template #activator="{ on }">
                <mf-button color="cinza-0" icon="edit_square" type="icon" @click="editGroup(item)" />
              </template>
              <span>Editar grupo</span>
            </mf-tooltip>
          </td>
          <td>
            <mf-tooltip max-width="200" top>
              <template #activator="{ on }">
                <mf-button color="cinza-0" icon="delete" type="icon" @click="deleteGroup(item._id)" />
              </template>
              <span>Deletar grupo</span>
            </mf-tooltip>
          </td>
        </tr>
      </template>
    </paginated-data-table>
    <edit-group-dialog v-if="openDialog" :selected-group-to-edit="selectedGroupToEdit" @update-table="updateTable" @close="closeDialog" />
  </mf-card-container>
</template>

<script>
import EditGroupDialog from './EditGroupDialog.vue'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { GET_UNIT_GROUPS, DELETE_UNIT_GROUP } from '@/modules/configuracoes/lojas/graphql'
import { putEllipsis } from '@/config/helpers.js'
import { sanitizeUnits } from '@/helpers/units'
export default {
  name: 'UnitsGroupContainer',
  components: { EditGroupDialog, PaginatedDataTable },
  data: () => ({
    search: '',
    openDialog: false,
    selectedGroupToEdit: {},
  }),
  computed: {
    headers() {
      const headers = [
        {
          text: 'Nome',
          value: 'name',
          width: '280px',
        },
        {
          text: 'Lojas',
          value: 'units',
          width: 'auto',
        },
        {
          text: '',
          value: 'edit',
          width: '40px',
          sortable: false,
        },
        {
          text: '',
          value: 'delete',
          width: '40px',
          sortable: false,
        },
      ]
      return headers
    },
    query() {
      return GET_UNIT_GROUPS
    },
  },
  methods: {
    sanitizeUnits,
    putEllipsis,
    async updateTable() {
      await this.$refs.table.waitAndGetData()
    },
    getChips(chips) {
      if (chips.length <= 4) return chips
      return chips.slice(0, 4)
    },
    editGroup(item) {
      this.selectedGroupToEdit = {
        _id: item._id,
        name: item.name,
        units: sanitizeUnits(item.units).map((unit) => unit.id_erp),
      }
      this.openDialog = true
    },
    closeDialog() {
      this.selectedGroupToEdit = null
      this.openDialog = false
    },
    async deleteGroup(_id) {
      await this.$confirm({
        title: 'Remover grupo',
        message: 'Tem certeza? Remover esse grupo de precificação remove essa informação de todas as lojas inseridas nele. Essa ação não poderá ser desfeita.',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => {
          this.confirmDeleteGroup(_id)
        })
        .catch(() => {})
    },
    async confirmDeleteGroup(_id) {
      await this.$apollo
        .mutate({
          mutation: DELETE_UNIT_GROUP,
          variables: { _id },
          fetchPolicy: 'no-cache',
        })
        .then(() => {
          this.$snackbar({ message: 'Grupo de precificação removido com sucesso', snackbarColor: 'success' })
          this.updateTable()
        })
        .catch((err) => {
          console.log(err)
          this.$snackbar({ message: 'Erro ao remover grupo de precificação', snackbarColor: 'error' })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}
</style>
